import Outlet from './component';

export default Outlet;
